__turbopack_context__.v({
  "selectUser__chooseNewEntityItem": "SelectNewOwner-module__exjgbW__selectUser__chooseNewEntityItem",
});
